import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { optionLabelPipe } from '@df/ui/common/option-label.pipe';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter } from 'rxjs/operators';
import { AbstractCmsBlockComponent } from '../../../../../../cms/block/abstract-cms-block.component';
import { CustomDropdownComponent } from '../../../../../../common/custom-dropdown/custom-dropdown.component';
import { ProductLayoutComponent } from '../../product-layout.component';
import { productSizeGuideConfig } from './product-layout-sidebar-size-guide.config';
import { IProductSizeGuideContent } from './product-layout-sidebar-size-guide.interfaces';

@Component({
    selector: 'product-layout-sidebar-size-guide',
    templateUrl: './product-layout-sidebar-size-guide.component.html',
    styleUrl: './product-layout-sidebar-size-guide.component.scss',
    imports: [CommonModule, CustomDropdownComponent, ICmsClientModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductLayoutSidebarSizeGuideComponent>(productSizeGuideConfig)
export class ProductLayoutSidebarSizeGuideComponent
    extends AbstractCmsBlockComponent
    implements NICmsContentComponent.IComponent, OnInit, OnDestroy
{
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductSizeGuideContent;

    readonly productViewLayout = input.required<ProductLayoutComponent>();

    selectedModal?: string = '';
    brandAttrValue?: string;

    readonly tableToggleId: NToggle.TId = ['table', 0];

    private readonly routerSubscription = new Subscription();
    private readonly toggleService = inject(ToggleService);
    private readonly router = inject(Router);

    get tableSelectState() {
        return this.toggleService.getState(this.tableToggleId);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.selectAttrValue();

        this.routerSubscription.add(
            this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
                this.selectAttrValue();
            })
        );
    }

    override ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();

        super.ngOnDestroy();
    }

    onModelChange(): void {
        this.detectChanges();
    }

    selectTable(title: string): void {
        this.selectedModal = title;
        this.closeTableSelect();
        this.detectChanges();
    }

    toggleTableSelect(): void {
        this.toggleService.toggle(this.tableToggleId);
    }

    closeTableSelect(): void {
        this.toggleService.close(this.tableToggleId);
    }

    private prepareProductBrandAttr(): void {
        const brandFilterAttr = this.productViewLayout().product().data?.brand_filter?.[0];

        if (brandFilterAttr) {
            this.brandAttrValue = optionLabelPipe(brandFilterAttr, 'brand_filter')?.toString();
        } else {
            this.brandAttrValue = undefined;
        }
    }

    private selectAttrValue(): void {
        this.timeoutService.setTimeout(() => {
            this.prepareProductBrandAttr();

            const brandFilterTable = this.content?.tables.find(table => table.title === this.brandAttrValue);
            this.selectedModal = brandFilterTable ? this.brandAttrValue : this.content?.tables[0]?.title;

            this.detectChanges();
        }, 1000);
    }
}
